import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDownToBase = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "m13 12.2 3.2-3.3 1.5 1.4L12 16l-5.7-5.7L7.8 9l3.2 3.3V4h2v8.2z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22 21H2v-9h2v7h16v-7h2v9z"
	})]
});
export default SvgArrowDownToBase;
